const { isCordovaRunning } = require('utils/cordova');

module.exports = function initViewportHeight() {

    // Let Cordova keep the default 100vh for the height calc.
    if (isCordovaRunning()) {
        return;
    }

    const root = document.documentElement;

    // Set to dvh if it's supported. This is intended to target desktop and mobile browsers.
    if (CSS.supports('height: 100dvh')) {
        root.style.setProperty('--app-height', '100dvh');
        return;
    }

    function setAppHeight() {

        const height = window.visualViewport?.height || window.innerHeight;
        root.style.setProperty('--app-height', `${height}px`);
    }

    // Initial set
    setAppHeight();

    // Event listeners
    const onResize = () => setAppHeight();

    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);

    if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', onResize);
        window.visualViewport.addEventListener('scroll', onResize);
    }
}
